import { formatDate } from '@/utils/date';
import { RouteName } from '@/router/routes';
import { VueConstructor } from 'vue';
import { hasAnyRole, hasRole } from '@/utils/auth/has-role';
import { Roles } from '@/utils/auth/roles';
import { formatCurrency, formatDecimal } from '@/utils/decimal';
import { formatPhoneNumber } from '@/utils/phone-number';

export default {
  install (Vue: VueConstructor): void {
    Vue.mixin({
      computed: {
        isMobile (): boolean {
          return (this.$vuetify as any).breakpoint.xsOnly;
        },
        isTablette (): boolean {
          return (this.$vuetify as any).breakpoint.sm;
        },
        RouteName (): RouteName {
          return RouteName;
        },
        Roles (): Roles {
          return Roles;
        }
      },
      methods: {
        hasRole (...roles: string[]): boolean {
          return hasRole(...roles);
        },
        hasAnyRole (...roles: string[]): boolean {
          return hasAnyRole(...roles);
        }
      }
    });

    Vue.filter('date', formatDate);
    Vue.filter('phone', formatPhoneNumber);
    Vue.filter('decimal', formatDecimal);
    Vue.filter('currency', formatCurrency);
  }
};
